<template>
    <div class="toAskBox" id="toAskBoxDiv">
        <topImg :imgHeight="imgHeight" :background="background" :showInput="false"></topImg>
        <!--<div class="imgDiv">
            <img src="../../../static/img/404_bg.png" height="361" width="494"/>
        </div>-->
        <onlyContent></onlyContent>
    </div>
</template>

<script>
    import topImg from "../pages/indexPages/topImg.vue"
    import onlyContent from "../common/onlyContent.vue"

    import $ from 'jquery/dist/jquery'

    export default {
        name: "toAsk",
        components:{topImg,onlyContent},
        data(){
            return{
                imgHeight:"117px",
                background:"transparent"
            }
        },
        mounted() {
            $("#toAskBoxDiv").scroll(function (){
                if (
                    !!$("#toAskBoxDiv").scrollTop() &&
                    $("#toAskBoxDiv").scrollTop() > 120
                ) {
                    $(".headerDiv").hide();
                    $(".topHeaderLine").hide();
                } else {
                    $(".headerDiv").show();
                    $(".topHeaderLine").show();
                }
            });
        }
    }
</script>

<style lang="less" scoped>
    @import url("../../../static/css/common.less");
    .toAskBox{
        width:100%;
        height:100%;
        .imgDiv{
            width: @indexCommonWidth;
            margin: 5% auto;
            text-align: center;
        }
    }
</style>
